import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
function isRrwebError(event) {
  if (event.type || !_optionalChain([event, 'access', function (_) {
    return _.exception;
  }, 'optionalAccess', function (_2) {
    return _2.values;
  }, 'optionalAccess', function (_3) {
    return _3.length;
  }])) {
    return false;
  }

  // Check if any exception originates from rrweb
  return event.exception.values.some(function (exception) {
    if (!_optionalChain([exception, 'access', function (_4) {
      return _4.stacktrace;
    }, 'optionalAccess', function (_5) {
      return _5.frames;
    }, 'optionalAccess', function (_6) {
      return _6.length;
    }])) {
      return false;
    }
    return exception.stacktrace.frames.some(function (frame) {
      return _optionalChain([frame, 'access', function (_7) {
        return _7.filename;
      }, 'optionalAccess', function (_8) {
        return _8.includes;
      }, 'call', function (_9) {
        return _9('/rrweb/src/');
      }]);
    });
  });
}
export { isRrwebError };